// Hello and welcome to your Atlassian backend coding interview
export class RateLimiter {
	private lastReset = new Date();

	private counters: Map<string, number> = new Map();

	// windowSize in seconds
	private windowSize: number;

	// after this many events with a particular key, they will be dropped
	private dropAfterCount: number;

	constructor(windowSize: number, dropAfterCount: number) {
		if (dropAfterCount <= 0) {
			throw new Error('dropAfterCount must be greater than 0');
		}
		this.windowSize = windowSize;
		this.dropAfterCount = dropAfterCount;
	}

	async rateLimit(
		key: string,
		fn: () => void | Promise<void>,
		onLimited: () => void | Promise<void>,
	): Promise<void> {
		const now = new Date();
		if (now.getTime() - this.lastReset.getTime() > this.windowSize * 1000) {
			this.lastReset = now;
			this.counters.clear();
		}

		const count = this.counters.get(key) || 0;
		if (count >= this.dropAfterCount) {
			return onLimited();
		}

		this.counters.set(key, count + 1);
		return fn();
	}
}
